module.exports = __webpack_public_path__ + "img/documents--avatar.b5a5754f.svg";